"use client";

import React from "react";
import { useLocale } from "hooks";
import { Link } from "components/Link";
import { useTrustPilotWidget } from "./TrustPilotWidget.hooks";
import { trustPilotConfig } from "./constants";
import { colours } from "@shared/ui.design-system";

type Props = {
  textColor?: string;
};

export const TrustPilotRatingWidget: React.FC<Props> = ({
  textColor = colours.secondary.light
}): JSX.Element => {
  const { trustPilotContainerRef } = useTrustPilotWidget();
  const locale = useLocale();

  return (
    <div
      ref={trustPilotContainerRef}
      className="trustpilot-widget"
      data-locale={locale}
      data-template-id={trustPilotConfig["new-data-template-id"]}
      data-businessunit-id={trustPilotConfig["data-businessunit-id"][locale]}
      data-style-height="20px"
      data-style-width="100%"
      data-theme={textColor === colours.secondary.light ? "dark" : "light"}
      data-text-color={textColor}
    >
      <Link
        href={trustPilotConfig.url[locale]}
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </Link>
    </div>
  );
};
